import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";

function isTokenExpired(_ref) {
  var expiresAt = _ref.expiresAt,
      clockDrift = _ref.clockDrift;
  var currentTime = Date.now();
  return currentTime + clockDrift > expiresAt;
}

var AuthClass = /*#__PURE__*/function () {
  function AuthClass() {
    _classCallCheck(this, AuthClass);
  }

  _createClass(AuthClass, [{
    key: "configure",
    value:
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */
    function configure(authResourcesConfig, authOptions) {
      this.authConfig = authResourcesConfig;
      this.authOptions = authOptions;
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
     * with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */

  }, {
    key: "fetchAuthSession",
    value: function () {
      var _fetchAuthSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _credentialsAndIdenti, _credentialsAndIdenti2;

        var options,
            credentialsAndIdentityId,
            userSub,
            tokens,
            _tokens$accessToken,
            _tokens$accessToken$p,
            _this$authOptions,
            _this$authOptions$cre,
            _this$authOptions2,
            _this$authOptions2$cr,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.next = 3;
                return this.getTokens(options);

              case 3:
                tokens = _context.sent;

                if (!tokens) {
                  _context.next = 11;
                  break;
                }

                userSub = (_tokens$accessToken = tokens.accessToken) === null || _tokens$accessToken === void 0 ? void 0 : (_tokens$accessToken$p = _tokens$accessToken.payload) === null || _tokens$accessToken$p === void 0 ? void 0 : _tokens$accessToken$p.sub; // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)

                _context.next = 8;
                return (_this$authOptions = this.authOptions) === null || _this$authOptions === void 0 ? void 0 : (_this$authOptions$cre = _this$authOptions.credentialsProvider) === null || _this$authOptions$cre === void 0 ? void 0 : _this$authOptions$cre.getCredentialsAndIdentityId({
                  authConfig: this.authConfig,
                  tokens: tokens,
                  authenticated: true,
                  forceRefresh: options.forceRefresh
                });

              case 8:
                credentialsAndIdentityId = _context.sent;
                _context.next = 14;
                break;

              case 11:
                _context.next = 13;
                return (_this$authOptions2 = this.authOptions) === null || _this$authOptions2 === void 0 ? void 0 : (_this$authOptions2$cr = _this$authOptions2.credentialsProvider) === null || _this$authOptions2$cr === void 0 ? void 0 : _this$authOptions2$cr.getCredentialsAndIdentityId({
                  authConfig: this.authConfig,
                  authenticated: false,
                  forceRefresh: options.forceRefresh
                });

              case 13:
                credentialsAndIdentityId = _context.sent;

              case 14:
                return _context.abrupt("return", {
                  tokens: tokens,
                  credentials: (_credentialsAndIdenti = credentialsAndIdentityId) === null || _credentialsAndIdenti === void 0 ? void 0 : _credentialsAndIdenti.credentials,
                  identityId: (_credentialsAndIdenti2 = credentialsAndIdentityId) === null || _credentialsAndIdenti2 === void 0 ? void 0 : _credentialsAndIdenti2.identityId,
                  userSub: userSub
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchAuthSession() {
        return _fetchAuthSession.apply(this, arguments);
      }

      return fetchAuthSession;
    }()
  }, {
    key: "clearCredentials",
    value: function () {
      var _clearCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$authOptions3, _this$authOptions3$cr;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (_this$authOptions3 = this.authOptions) === null || _this$authOptions3 === void 0 ? void 0 : (_this$authOptions3$cr = _this$authOptions3.credentialsProvider) === null || _this$authOptions3$cr === void 0 ? void 0 : _this$authOptions3$cr.clearCredentialsAndIdentityId();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function clearCredentials() {
        return _clearCredentials.apply(this, arguments);
      }

      return clearCredentials;
    }()
  }, {
    key: "getTokens",
    value: function () {
      var _getTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
        var _yield$this$authOptio, _this$authOptions4, _this$authOptions4$to;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (_this$authOptions4 = this.authOptions) === null || _this$authOptions4 === void 0 ? void 0 : (_this$authOptions4$to = _this$authOptions4.tokenProvider) === null || _this$authOptions4$to === void 0 ? void 0 : _this$authOptions4$to.getTokens(options);

              case 2:
                _context3.t1 = _yield$this$authOptio = _context3.sent;
                _context3.t0 = _context3.t1 !== null;

                if (!_context3.t0) {
                  _context3.next = 6;
                  break;
                }

                _context3.t0 = _yield$this$authOptio !== void 0;

              case 6:
                if (!_context3.t0) {
                  _context3.next = 10;
                  break;
                }

                _context3.t2 = _yield$this$authOptio;
                _context3.next = 11;
                break;

              case 10:
                _context3.t2 = undefined;

              case 11:
                return _context3.abrupt("return", _context3.t2);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getTokens(_x) {
        return _getTokens.apply(this, arguments);
      }

      return getTokens;
    }()
  }]);

  return AuthClass;
}();

export { AuthClass, isTokenExpired };